import {
  ACTION_REQUEST_SUFFIX,
  ACTION_FAILURE_SUFFIX,
  createAPIActionDispatcher,
} from '../../lib/redux';

export const ACTION_LOGIN = 'account/LOGIN';
export const ACTION_AZURE_LOGIN = 'account/AZURE_LOGIN';
export const ACTION_LOGOUT = 'account/LOGOUT';
export const ACTION_FETCH_USER = 'account/FETCH_USER';
export const ACTION_CLEAR_MESSAGES = 'account/CLEAR_MESSAGES';
export const ACTION_SSO_LOGIN = 'account/SSO_LOGIN';

export const ACTION_LOGIN_REQUEST = `${ACTION_LOGIN}${ACTION_REQUEST_SUFFIX}`;
export const ACTION_LOGIN_FAILURE = `${ACTION_LOGIN}${ACTION_FAILURE_SUFFIX}`;
export const ACTION_AZURE_LOGIN_REQUEST = `${ACTION_AZURE_LOGIN}${ACTION_REQUEST_SUFFIX}`;
export const ACTION_AZURE_LOGIN_FAILURE = `${ACTION_AZURE_LOGIN}${ACTION_FAILURE_SUFFIX}`;
export const ACTION_LOGOUT_REQUEST = `${ACTION_LOGOUT}${ACTION_REQUEST_SUFFIX}`;
export const ACTION_LOGOUT_FAILURE = `${ACTION_LOGOUT}${ACTION_FAILURE_SUFFIX}`;
export const ACTION_FETCH_USER_REQUEST = `${ACTION_FETCH_USER}${ACTION_REQUEST_SUFFIX}`;
export const ACTION_FETCH_USER_FAILURE = `${ACTION_FETCH_USER}${ACTION_FAILURE_SUFFIX}`;

const URI_ACCOUNT_LOGOUT = '/api/Account/Logout';
const URI_ACCOUNT_FETCH = '/api/Account/Profile';
const URI_ACCOUNT_AZURE_LOGIN = '/api/Account/AzureLogin';

export function fetchUser(silent) {
  return createAPIActionDispatcher(
    ACTION_FETCH_USER,
    { silent },
    {
      uri: URI_ACCOUNT_FETCH,
    }
  );
}

export function azureLogin(user) {
  return createAPIActionDispatcher(
    ACTION_LOGIN,
    {},
    {
      uri: URI_ACCOUNT_AZURE_LOGIN,
      body: JSON.stringify(user),
      then: (dispatch, getState) => fetchUser()(dispatch, getState),
    }
  );
}

export function ssoLogin(token) {
  return (dispatch) => {
    dispatch({ type: ACTION_SSO_LOGIN, token });
  };
}

export function logout() {
  return createAPIActionDispatcher(
    ACTION_LOGOUT,
    {},
    {
      uri: URI_ACCOUNT_LOGOUT,
      body: null,
    }
  );
}

export function clearMessages() {
  return (dispatch) => {
    dispatch({ type: ACTION_CLEAR_MESSAGES });
  };
}
